import {
   clsx
  ,Box
  ,Radio
  ,RadioGroup
  ,FormControlLabel
} from 'external/material'

import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

export default function TrueOrFalse ({question}) {

  const {translate} = useTranslations()
  const {assessment, save} = useAssessment()

  const answer = assessment.answers[question.id]

  const handleChange = e => save({[question.id]: {value: {$set: e.target.value == "true"}, completed: {$set: true}}})

  return (
    <Box className={clsx("question", "true-or-false")}>
      <Box className={clsx("answer")}>
        <RadioGroup className="content" value={answer.value} onChange={handleChange}>
          <FormControlLabel value={true} control={<Radio />} label={translate('true')} />
          <FormControlLabel value={false} control={<Radio />} label={translate('false')} />
        </RadioGroup>
      </Box>
    </Box>
  )
}

